export var USER_ID_TYPE_OWNER = 'owner';
export var USER_ID_TYPE_USER = 'user';
export var USER_ID_TYPE_SITE_MEMBER = 'sitemember';
